import { render, staticRenderFns } from "./EnlistmentDispatch.vue?vue&type=template&id=19a8b2ed&"
import script from "./EnlistmentDispatch.vue?vue&type=script&lang=js&"
export * from "./EnlistmentDispatch.vue?vue&type=script&lang=js&"
import style0 from "./EnlistmentDispatch.vue?vue&type=style&index=0&id=19a8b2ed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports